import SkyTPOLogin from './skyTPOLogin';
import ChampsTPOLogin from './tpoLogin';
import { getLoginVariant } from '../../utils/organizationConfigUtil';
import { LOGIN_VARIANTS, DEFAULT_ORG_ID, ORGANIZATIONS } from '../../config/organizations';

const LOGIN_COMPONENTS = {
  [LOGIN_VARIANTS.CHAMPSTPO]: ChampsTPOLogin,
  [LOGIN_VARIANTS.SKYTPO]: SkyTPOLogin
};

function LoginSwitcher() {
  const Login = LOGIN_COMPONENTS[getLoginVariant()] ?? LOGIN_COMPONENTS[ORGANIZATIONS[DEFAULT_ORG_ID].loginVariant];
  return <Login />;
}

export default LoginSwitcher;
